import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex, Select } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import { DARK } from '../../utilities/constants';
import Icon from '@ant-design/icons';
import { ReactComponent as Reset } from '../../assets/icons/reset.svg';
import { ReactComponent as ResetBlack } from '../../assets/icons/reset-black.svg';
import { ReactComponent as Cancel } from '../../assets/icons/cancel.svg';
import { ReactComponent as CancelBlack } from '../../assets/icons/cancel-black.svg';
import { ReactComponent as SelectDropdownSvg } from '../../assets/icons/select-dropdown.svg';
import { ReactComponent as SelectDropdownBlackSvg } from '../../assets/icons/select-dropdown-black.svg';
import EmptyCard from '../EmptyCard/EmptyCard';

const FilterSelectDropdown = ({
  options = [],
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  close,
  dataIndex,
  handleFilterSelect,
  handleReset,
  tableParams,
  placeholder,
}) => {
  const { theme } = useTheme();

  useEffect(() => {
    setSelectedKeys([tableParams?.filters?.[dataIndex] || '']);
  }, [tableParams]);

  return (
    <Flex
      vertical
      gap={12}
      style={{
        padding: 16,
        backgroundColor: theme === DARK ? '#000000' : '#FFFFFF',
      }}
      onKeyDown={e => e.stopPropagation()}
    >
      <Flex gap={12} justify="flex-end">
        <Icon
          component={theme === DARK ? Reset : ResetBlack}
          onClick={() => {
            clearFilters &&
              handleReset(clearFilters, setSelectedKeys, dataIndex, confirm);
          }}
        />
        <Icon
          component={theme === DARK ? Cancel : CancelBlack}
          onClick={close}
        />
      </Flex>
      <Select
        className="custom-select-dropdown"
        showSearch
        placeholder={`Select ${placeholder}`}
        value={selectedKeys[0] || undefined}
        options={options}
        size="large"
        style={{ width: '200px' }}
        onChange={value => {
          setSelectedKeys(value ? [value] : ['']);
          handleFilterSelect(value ? [value] : [''], confirm, dataIndex);
        }}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        suffixIcon={
          <Icon
            component={
              theme === DARK ? SelectDropdownSvg : SelectDropdownBlackSvg
            }
            style={{
              pointerEvents: 'none',
            }}
          />
        }
        notFoundContent={<EmptyCard />}
      />
    </Flex>
  );
};

FilterSelectDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  setSelectedKeys: PropTypes.func.isRequired,
  selectedKeys: PropTypes.array.isRequired,
  confirm: PropTypes.func.isRequired,
  clearFilters: PropTypes.func,
  close: PropTypes.func.isRequired,
  dataIndex: PropTypes.string.isRequired,
  handleFilterSelect: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  tableParams: PropTypes.object,
  placeholder: PropTypes.string,
};

export default FilterSelectDropdown;
